import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";

import MapAssetAndDevicesJS from "components/maps/MapAssetAndDevicesJS";
import CoordinatesShow from "components/coords/CoordinatesShow";
import ConditionalRender from "components/ConditionalRender";
import CoordinatesInputs from "components/coords/CoordinatesInputs";
import { useTranslation } from "react-i18next";

const TabGeneral = ({ item, deviceTypes, deviceGroups, deviceStatus, handleModalMap, setFormData }) => {
    const [showMap, setShowMap] = useState(false);
    const { t: _Tt } = useTranslation("tags");
    const { t: _TT } = useTranslation("tables");

    useEffect(() => {
        setShowMap(true);
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <>
            <div className="container mb-5 pb-4">
                <div className="row">
                    <div className="col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="uuid" className="form-label">
                                UUID
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="text"
                            className="form-control mb-2"
                            id="uuid"
                            name="uuid"
                            defaultValue={item.uuid}
                            required
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="serial" className="form-label">
                                {_Tt("common.serial")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="text"
                            className="form-control mb-2"
                            id="serial"
                            name="serial"
                            defaultValue={item.serial}
                            required
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="type" className="form-label">
                                {_Tt("common.type")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <Form.Select className="mb-2" id="type" name="type" defaultValue={item.type}>
                            <option value="">-</option>
                            {deviceTypes.map((type, index) => (
                                <option key={index} value={type[0]}>
                                    {type[1]}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="status" className="form-label">
                                {_TT("devices.groups_devices")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <Form.Select className="mb-2" id="group" name="group" defaultValue={item.group}>
                            <option value="">-</option>
                            {deviceGroups.map((group, index) => (
                                <option key={index} value={group.id}>
                                    {group.name}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="status" className="form-label">
                                {_TT("devices.status")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <Form.Select className="mb-2" id="status" name="status" defaultValue={item.status}>
                            <option value="">-</option>
                            {deviceStatus.map(([key, label], index) => (
                                <option key={index} value={key}>
                                    {label}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <CoordinatesInputs item={item} handleChange={handleChange} handleModalMap={handleModalMap} />
                    </div>
                    <div className="col-md-3"></div>
                </div>

                <ConditionalRender condition={item.asset && item.asset.id}>
                    <div className="row mt-3">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <CoordinatesShow item={item.asset} />
                        </div>
                    </div>
                </ConditionalRender>

                <div className="row mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="description" className="col-form-label">
                            {_TT("devices.note")}
                        </label>
                    </div>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            id="notes"
                            name="notes"
                            defaultValue={item.notes}
                            rows="4"
                        />
                    </div>
                </div>

                <div className="mt-4 preview-item">
                    <MapAssetAndDevicesJS
                        asset={item.asset}
                        devices={[item]}
                        mapId="map-device-preview"
                        height="220px"
                        zoom={13}
                        show={showMap}
                    />
                </div>
            </div>
        </>
    );
};
export default TabGeneral;
